import React, { Component } from 'react';
import axios from 'axios';
import config from '../config';
// import './OtpScreen.css'; // Assuming you have a CSS file for custom styles

class OtpScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            otp: ['', '', '', '', '', ''],
            validationMessage: '',
            timeLeft: 180,
            attempt: 1,
            isLocked: false,
            lockTimeLeft: 0,
        };
        this.handleOtpChange = this.handleOtpChange.bind(this);
        this.handleOtpSubmit = this.handleOtpSubmit.bind(this);
        this.resendOtp = this.resendOtp.bind(this);
        this.startTimer = this.startTimer.bind(this);
        this.startLockTimer = this.startLockTimer.bind(this);
    }

    componentDidMount() {
        this.startTimer();
    }

    startTimer() {
        this.timer = setInterval(() => {
            if (this.state.timeLeft > 0) {
                this.setState(prevState => ({ timeLeft: prevState.timeLeft - 1 }));
            } else {
                clearInterval(this.timer);
            }
        }, 1000);
    }

    startLockTimer() {
        this.lockTimer = setInterval(() => {
            if (this.state.lockTimeLeft > 0) {
                this.setState(prevState => ({ lockTimeLeft: prevState.lockTimeLeft - 1 }));
            } else {
                clearInterval(this.lockTimer);
                this.setState({ isLocked: false, attempt: 1 });
            }
        }, 1000);
    }

    handleOtpChange(event, index) {
        const otp = [...this.state.otp];
        otp[index] = event.target.value;
        this.setState({ otp });

        // Move to the next input field if the current one is filled
        if (event.target.value && index < 5) {
            this[`otpInput${index + 1}`].focus();
        }
    }

    handleOtpSubmit(event) {
        event.preventDefault();
        const { _email, partialLoginToken, redirectURL,subDomain } = this.props.location.state;
        const otp = this.state.otp.join('');

        // Call validateOTPAndLogin API with OTP
        axios.post(config.validateOtp, {
            otp,
            partialLoginToken,
            email: _email,
            subDomain:subDomain
        })
        .then(response => {
            if (response.status === 200) {
                // handle success                
                if (this.state.rememberMe) {
                    localStorage.token = response.data.data.token;
                    localStorage.isAuthenticated = true;
                }
                this.setState({
                    token: response.data.data[0],
                    isAuthenticated: true,
                });
                const redirectURL_ = `${redirectURL}?token=${response.data.data.token}`;
                window.location.replace(redirectURL_);
            } else {
                throw new Error(response.statusText);
            }
        })
        .catch(error => {
            // Handle verification failure
            console.error('Error verifying login:', error);
            this.setState(prevState => {
                const newAttempt = prevState.attempt + 1;
                if (newAttempt > 3) {
                    this.setState({
                        isLocked: true,
                        lockTimeLeft: 60, // 1 minute lock
                        validationMessage: 'Too many attempts. System will be temporarily locked for 1 min after 3 unsuccessful attempts.',
                        attempt: 3 // Ensure the attempt does not exceed 3
                    });
                    this.startLockTimer();
                } else {
                    return {
                        validationMessage: 'Verification failed. Please try again.',
                        attempt: newAttempt,
                    };
                }
            });
        });
    }

    resendOtp() {
        // Logic to resend OTP
        console.log("Resending OTP...");
        this.setState({ timeLeft: 180 });
        this.startTimer();
    }

    handleBackClick = () => {
        this.props.history.goBack();
    };

    render() {
        const { otp, validationMessage, timeLeft, attempt, isLocked, lockTimeLeft } = this.state;
        const isOtpComplete = otp.every(digit => digit !== ''); // Check if all OTP inputs are filled
        return (
            <div className="container">
                <div className="card card-login mx-auto mt-5">
                    <div className="login-logo"></div>
                    <div className="login-header text-center">Two Factor Authentication</div>
                    <div className="card-body">
                        <div className="text-center mb-4 lightgray">Please enter your OTP</div>
                        <form onSubmit={this.handleOtpSubmit}>
                            <div className="form-group otp-inputs">
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        type="text"
                                        className="form-control otp-input"
                                        maxLength="1"
                                        value={digit}
                                        onChange={(e) => this.handleOtpChange(e, index)}
                                        ref={(input) => this[`otpInput${index}`] = input}
                                        disabled={isLocked}
                                    />
                                ))}
                            </div>
                            <div className="otp-controls d-flex justify-content-between">
                                <div className="timer">
                                    {String(Math.floor(timeLeft / 60)).padStart(2, '0')}:
                                    {String(timeLeft % 60).padStart(2, '0')}
                                </div>
                                <button type="button" onClick={this.resendOtp} className="btn btn-link resend-otp" disabled={timeLeft > 0 || isLocked}>Resend OTP</button>
                            </div>
                            <div className="text-left font-weight-bold mt-1">
                            Attempt {attempt}/3
                        </div>
                            <div className="text-left small-font my-2 lightgray">
                            Note: You will be locked out of the system for 1 minute upon 3 unsuccessful attempts.
                        </div>
                            <button type="submit" className="btn btn-primary btn-block" disabled={!isOtpComplete || isLocked}>
                                Submit OTP
                            </button>
                        </form>
                        {validationMessage && (
                            <div className="alert alert-danger mt-4" role="alert">
                                {validationMessage}
                            </div>
                        )}
                        
                        {isLocked && (
                            <div className="text-center mt-3 lightgray">
                                System locked. Please wait {lockTimeLeft} seconds.
                            </div>
                        )}
                        <div className="text-center mt-3 blue" style={{ cursor: 'pointer',color: "#007bff" }} onClick={this.handleBackClick}>
                            Back
                        </div>
                    </div>
                    <div className="login-footer">
                        &copy; 2024 Reliance Industries Limited. All rights reserved.
                    </div>
                </div>
            </div>
        );
    }
}

export default OtpScreen;



// WEBPACK FOOTER //
// ./src/components/OtpScreen.js